import { useState } from 'preact/hooks';
import { get } from '../api';
import { me } from '../session';
import { Button, Card, Empty, Link, Loading, navigate, Pill, timeAgo, useLoad } from '../ui';
import { GameCard } from './Browse';

export function Home() {
	const m = me.use();
	const games = useLoad(() => get('/api/games/mine'));
	const stories = useLoad(() => get('/api/stories'));
	const [code, setCode] = useState('');
	const go = () => {
		const c = code.toUpperCase().replace(/[^A-Z0-9]/g, '');
		if (c.length === 6) navigate(`/g/${c}`);
	};
	const plan = m?.plan;
	return (
		<main class="page">
			<h1>Welcome, {m?.user?.displayName}</h1>
			<div class="two-col">
				<Card title="Join a game">
					<form
						class="join-code"
						onSubmit={(e) => {
							e.preventDefault();
							go();
						}}
					>
						<input value={code} onInput={(e) => setCode(e.currentTarget.value)} placeholder="K7MX-QP" maxLength={7} aria-label="Game code" autocapitalize="characters" />
						<Button type="submit" disabled={code.replace(/[^A-Za-z0-9]/g, '').length !== 6}>
							Join
						</Button>
					</form>
					<p>
						or <Link href="/browse">browse public games</Link>.
					</p>
				</Card>
				<Card title="Create a game">
					<p>Start from your own story, a template from your library, or the sample dungeon.</p>
					<div class="row">
						<Button onClick={() => navigate('/create')}>Create a game</Button>
						<Button variant="ghost" onClick={() => navigate('/stories')}>
							Write a story
						</Button>
					</div>
					{plan ? (
						<p class="small muted">
							{plan.def.name} plan · {plan.def.activeGames} active game{plan.def.activeGames > 1 ? 's' : ''} · up to {plan.def.maxPlayers} players
							{plan.allowance ? ` · ${Math.round(plan.remaining)} beats left` : ''}
						</p>
					) : null}
				</Card>
			</div>
			<Card title="Your games">
				{!games.data ? (
					<Loading />
				) : games.data.games.length ? (
					<div class="grid-cards">
						{games.data.games.map((g: any) => (
							<GameCard key={g.code} g={g} mine />
						))}
					</div>
				) : (
					<Empty>You haven't joined any games yet.</Empty>
				)}
			</Card>
			<Card title="Your stories" actions={<Link href="/stories">All stories</Link>}>
				{stories.data?.stories?.length ? (
					<ul class="list">
						{stories.data.stories.slice(0, 5).map((s: any) => (
							<li key={s.id}>
								<Link href={`/stories/${s.id}`}>{s.title}</Link> <Pill tone={s.status === 'compiled' ? 'ok' : 'muted'}>{s.status}</Pill> <span class="muted small">{timeAgo(s.updated_at)}</span>
							</li>
						))}
					</ul>
				) : (
					<Empty>No stories yet.</Empty>
				)}
			</Card>
		</main>
	);
}
